import { Modal, styled } from '@mui/material';
import { ZIndexes } from 'enums/z-indexes';

export const CenteredModal = styled(Modal)({
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: ZIndexes.External_Top_First,
});
